var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTakeawayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 11L27.692 43l-6.375-6.376L14.967 43 8 36.034l6.376-6.351L8 23.308 40 11z",
    fill: "#ADC6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.07V22h-3v-2.76l3-1.17z",
    fill: "#1D39C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 8a7.986 7.986 0 01-5.472 7.584c-.544.192-.928.832-.928 1.536v1.088l-3.2 1.248V17.12c0-2.112 1.248-3.936 3.104-4.576A4.744 4.744 0 0024.3 8c0-2.656-2.144-4.8-4.8-4.8A4.793 4.793 0 0014.7 8v1.6h-3.2V8c0-4.416 3.584-8 8-8s8 3.584 8 8zM17.9 25.6h3.2v3.2h-3.2v-3.2z",
    fill: "#597EF7"
  })));
}

export default __webpack_public_path__ + "./fonts/takeaway-icon.eaf00f96340e1c3cd1c48f53d1bcc815.svg";
export { SvgTakeawayIcon as ReactComponent };